/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import {
  baseApiV1,
  baseApiV2,
  baseApiV3,
  baseApiV3_1,
  baseApiV3_2,
} from "../../constants/Presets";
import { ORDER_DESC } from "../../constants/Constants";

// function that makes the api request and returns a Promise for response
export function FetchDatapipe(payload) {
  const url = `${baseApiV2}datapipe/list?`;
  const params = [];
  /* istanbul ignore next */
  if (payload.query) {
    const query = encodeURIComponent(payload.query).toString();
    params.push(`q=${query}`);
    // params.push(`q=${payload.query}`)
  }
  const order = payload.order || ORDER_DESC;
  params.push(`order=${order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 0;
  params.push(`size=${size}`);
  const customerCode = payload.companyId || "";
  params.push(`company_id=${customerCode}`);
  const order_by = payload.orderBy || "updatedOn";
  params.push(`order_by=${order_by}`);
  if (payload?.configuuid) {
    params.push(`collector_id=${payload.configuuid}`);
  }
  if (payload?.connectorId) {
    params.push(`connector_id=${payload.connectorId}`);
  }

  const { status } = payload;
  status === 1 || status === 0
    ? params.push(`active=${status}`)
    : params.push("active=");
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}
export function FetchADatapipe(datapipe) {
  return axios({
    method: "get",
    url: `${baseApiV3}datapipe?datapipe_id=${datapipe}`,
  });
}
export function FetchADatapipeV3(datapipe) {
  return axios({
    method: "get",
    url: `${baseApiV3_2}datapipe?datapipe_id=${datapipe}`,
  });
}

export function ChangeStatusDatapipe({ id, status, overrideValue }) {
  const url = `${baseApiV2}datapipe/updateStatus`;
  const params = { id };
  params.disabled = status;

  if (overrideValue && typeof overrideValue === "object") {
    const isCollector = overrideValue.source === "collector";
    Object.keys(overrideValue).forEach((key) => {
      if (key === "source") {
        params.source = overrideValue.source;
      } else if (key === "playHeadFrequency") {
        if (overrideValue.source === "override") {
          const value = Number(overrideValue[key]);
          params[key] = isNaN(value) ? overrideValue[key] : value * 1000;
        } else {
          params[key] = null;
        }
      } else {
        params[key] = isCollector ? null : overrideValue[key];
      }
    });
  }

  return axios.patch(url, params);
}

export function CreateDatapipe(datapipe) {
  const url = `${baseApiV3}datapipe`;
  return axios.post(url, datapipe);
}
export function CreateDatapipeV3(datapipe) {
  const url = `${baseApiV3_2}datapipe`;
  return axios.post(url, datapipe);
}
export function UpdateDatapipe(datapipe) {
  const url = `${baseApiV3}datapipe`;
  return axios.patch(url, datapipe);
}
export function UpdateDatapipe_V3_1(datapipe) {
  const url = `${baseApiV3_2}datapipe`;
  return axios.patch(url, datapipe);
}
export function DeleteDatapipe(datapipe) {
  const url = `${baseApiV3}datapipe?datapipe_id=${datapipe}`;
  return axios.delete(url);
}
export function DeleteDatapipe_V3_1(datapipe) {
  const url = `${baseApiV3_2}datapipe?datapipe_id=${datapipe}`;
  return axios.delete(url);
}
export function HidedataPipe(data) {
  const url = `${baseApiV3}datapipe/hide_from_customer`;
  const params = {
    datapipeId: data.datapipeId,
    hideFromCustomer: data.hideFromCustomer,
  };

  return axios.patch(url, params);
}
export function FetchAdatapipeLogs(payload) {
  return axios({
    method: "get",
    url: `${baseApiV3_2}datapipe/changeLog/${payload}`,
  });
}
